import { SiteActivityEvent, generator } from '@cms-max/cms-browser-api-client'
import { GeneratorArgs } from './generateEventMap'
import { Activity, Component } from '@cms-max/medicare-api-sdk'

export const premiumsEasyPayGenerator = generator(({ i18n }: GeneratorArgs) => {
  const createPremiumsEasyPayLinkClickHandler = (elementId: string) => (
    params: {
    linkText?: string,
    linkUrl?: string
  }): SiteActivityEvent => ({
    core: {
      elementId,
      property: 'MAX',
      activity: Activity.LinkClick,
      component: Component.EasyPay,
      coreClickData: {
        linkText: params.linkText,
        linkUrl: params.linkUrl
      }
    }
  })

  return {
    premiums_easypaylanding_easypayenroll_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaylanding_easypayenroll_click'
    ),
    premiums_easypaylanding_easypaystop_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaylanding_easypaystop_click'
    ),
    premiums_easypaylanding_changebank_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaylanding_changebank_click'
    ),
    premiums_easypaylanding_back_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaylanding_back_click'
    ),
    premiums_easypaysignup_cancel_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaysignup_cancel_click'
    ),
    premiums_easypaysignup_back_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaysignup_back_click'
    ),
    premiums_easypaysignupsuccess_makepayment_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaysignupsuccess_makepayment_click'
    ),
    premiums_easypaysignupsuccess_backtopremiums_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaysignupsuccess_backtopremiums_click'
    ),
    premiums_easypaysignupsuccess_back_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaysignupsuccess_back_click'
    ),
    premiums_easypaystop_cancel_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaystop_cancel_click'
    ),
    premiums_easypaystop_back_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaystop_back_click'
    ),
    premiums_easypaystopsuccess_otherwaystopay_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaystopsuccess_otherwaystopay_click'
    ),
    premiums_easypaystopsuccess_backtopremiums_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaystopsuccess_backtopremiums_click'
    ),
    premiums_easypaystopsuccess_back_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaystopsuccess_back_click'
    ),
    premiums_easypaychangebank_cancel_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaychangebank_cancel_click'
    ),
    premiums_easypaychangebank_back_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaychangebank_back_click'
    ),
    premiums_easypaychangebanksuccess_makepayment_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaychangebanksuccess_makepayment_click'
    ),
    premiums_easypaychangebanksuccess_easypaypage_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaychangebanksuccess_easypaypage_click'
    ),
    premiums_easypaychangebanksuccess_backtopremiums_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaychangebanksuccess_backtopremiums_click'
    ),
    premiums_easypaychangebanksuccess_back_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaychangebanksuccess_back_click'
    ),
    premiums_easypaylanding_backtopremiums_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypaylanding_backtopremiums_click'
    ),
    premiums_easypayerror_backtopremiums_click: createPremiumsEasyPayLinkClickHandler(
      'premiums_easypayerror_backtopremiums_click'
    ),
    premiums_easypaylanding_print_click: {
      core: {
        elementId: 'premiums_easypaylanding_print_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('print', { ns: 'common' })
        }
      }
    },
    premiums_easypaysignup_routinginfo_draweropen: {
      core: {
        elementId: 'premiums_easypaysignup_routinginfo_draweropen',
        property: 'MAX',
        activity: Activity.OpenDrawer,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('help.routing', { ns: 'easyPayCommon' })
        }
      }
    },
    premiums_easypaysignup_routinginfo_drawerclose: {
      core: {
        elementId: 'premiums_easypaysignup_routinginfo_drawerclose',
        property: 'MAX',
        activity: Activity.CloseDrawer,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('help.routing', { ns: 'easyPayCommon' })
        }
      }
    },
    premiums_easypaysignup_accountinfo_draweropen: {
      core: {
        elementId: 'premiums_easypaysignup_accountinfo_draweropen',
        property: 'MAX',
        activity: Activity.OpenDrawer,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('accountNumber.help', { ns: 'easyPayCommon' })
        }
      }
    },
    premiums_easypaysignup_accountinfo_drawerclose: {
      core: {
        elementId: 'premiums_easypaysignup_accountinfo_drawerclose',
        property: 'MAX',
        activity: Activity.CloseDrawer,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('accountNumber.help', { ns: 'easyPayCommon' })
        }
      }
    },
    premiums_easypaysignup_termsconditions_openaccordion: {
      core: {
        elementId: 'premiums_easypaysignup_termsconditions_openaccordion',
        property: 'MAX',
        activity: Activity.OpenAccordion,
        component: Component.EasyPay
      }
    },
    premiums_easypaysignup_termsconditions_closeaccordion: {
      core: {
        elementId: 'premiums_easypaysignup_termsconditions_closeaccordion',
        property: 'MAX',
        activity: Activity.CloseAccordion,
        component: Component.EasyPay
      }
    },
    premiums_easypaysignup_print_click: {
      core: {
        elementId: 'premiums_easypaysignup_print_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('print', { ns: 'common' })
        }
      }
    },
    premiums_easypaysignupsuccess_print_click: {
      core: {
        elementId: 'premiums_easypaysignupsuccess_print_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('print', { ns: 'common' })
        }
      }
    },
    premiums_easypaystop_print_click: {
      core: {
        elementId: 'premiums_easypaystop_print_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('print', { ns: 'common' })
        }
      }
    },
    premiums_easypaystopsuccess_print_click: {
      core: {
        elementId: 'premiums_easypaystopsuccess_print_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('print', { ns: 'common' })
        }
      }
    },
    premiums_easypaychangebank_routinginfo_draweropen: {
      core: {
        elementId: 'premiums_easypaychangebank_routinginfo_draweropen',
        property: 'MAX',
        activity: Activity.OpenDrawer,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('routing.help', { ns: 'easyPayCommon' })
        }
      }
    },
    premiums_easypaychangebank_routinginfo_drawerclose: {
      core: {
        elementId: 'premiums_easypaychangebank_routinginfo_drawerclose',
        property: 'MAX',
        activity: Activity.CloseDrawer,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('routing.help', { ns: 'easyPayCommon' })
        }
      }
    },
    premiums_easypaychangebank_accountinfo_draweropen: {
      core: {
        elementId: 'premiums_easypaychangebank_accountinfo_draweropen',
        property: 'MAX',
        activity: Activity.OpenDrawer,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('accountNumber.help', { ns: 'easyPayCommon' })
        }
      }
    },
    premiums_easypaychangebank_accountinfo_drawerclose: {
      core: {
        elementId: 'premiums_easypaychangebank_accountinfo_drawerclose',
        property: 'MAX',
        activity: Activity.CloseDrawer,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('accountNumber.help', { ns: 'easyPayCommon' })
        }
      }
    },
    premiums_easypaychangebank_termsconditions_openaccordion: {
      core: {
        elementId: 'premiums_easypaychangebank_termsconditions_openaccordion',
        property: 'MAX',
        activity: Activity.OpenAccordion,
        component: Component.EasyPay
      }
    },
    premiums_easypaychangebank_termsconditions_closeaccordion: {
      core: {
        elementId: 'premiums_easypaychangebank_termsconditions_closeaccordion',
        property: 'MAX',
        activity: Activity.CloseAccordion,
        component: Component.EasyPay
      }
    },
    premiums_easypaychangebank_print_click: {
      core: {
        elementId: 'premiums_easypaychangebank_print_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('print', { ns: 'common' })
        }
      }
    },
    premiums_easypaychangebanksuccess_print_click: {
      core: {
        elementId: 'premiums_easypaychangebanksuccess_print_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('print', { ns: 'common' })
        }
      }
    },
    premiums_easypaysignup_submit_click: {
      core: {
        elementId: 'premiums_easypaysignup_submit_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('buttons.submit', { ns: 'easyPayCommon' })
        }
      }
    },
    premiums_easypaystop_submit_click: {
      core: {
        elementId: 'premiums_easypaystop_submit_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('buttons.stop', { ns: 'easyPayStopPage' })
        }
      }
    },
    premiums_easypaychangebank_submit_click: {
      core: {
        elementId: 'premiums_easypaychangebank_submit_click',
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.EasyPay,
        coreClickData: {
          linkText: i18n.t('buttons.submit', { ns: 'easyPayCommon' })
        }
      }
    }
  }
})

export type premiumsEasyPayKeys = keyof ReturnType<
  typeof premiumsEasyPayGenerator
>

export default premiumsEasyPayGenerator
